<template>
  <div class="home">
    <Header></header>
    <div class="banner">
      <div class="banner-content">
        <div class="left-banner">
          <div class="title">产品优势</div>
          <div class="content">沐桦科技通过整合分散于用户家中的雾计算资源和网络资源，形成覆盖全球的分布式资源网络。</div>
        </div>
        <div class="right-banner">
          <img
            class=""
            src="./../assets/ipDetail/banner.png"
            alt="沐桦科技"
          />
        </div>
      </div>
    </div>
    <section class="ip-content">
      <div class="muhua-title">海量雾计算设备IP及宽带资源</div>
      <div class="content">沐桦科技通过整合分散于用户家中的雾计算资源和网络资源，形成覆盖全球的分布式资源网络。依托于上述资源，沐桦科技可以提供海量雾计算设备的IP及宽带资源，用户可以通过网关（ProxyGateway）介入分布式网络，并以代理的方式访问目标资源。 具体场景示意图如下：</div>
      <img
        class="border"
        src="./../assets/ipDetail/target.png"
        alt=""
      >
    </section>
    <section class="feature">
      <div class="muhua-title">产品特色</div>
      <div class="muhua-little-title common-width">由于汇集大量真实用户的雾计算节点以及强大的平台调度能力，沐桦科技能够为用户提供丰富的网络资源代理服务- <span>高质量动态代理</span>。 具体有以下特点：</div>
      <div class="content">
        <div class="card">
          <div class="left-content">
            <div class="feature-title">高可用</div>
            <div v-bind:class="['card-detail-wrap', {'specail-card': whichCard === 1} ]"  @mouseover="changeCard(1)">
              <div class="card-title">雾计算设备健康检查</div>
              <div class="card-detail">平台对在线设备进行健康检测，检测失败的雾计算节点回自动从代理网关的映射中替换掉，当然用户也可以选择关闭该功能，完全自主控制IP的替换。</div>
            </div>
            <div v-bind:class="['card-detail-wrap', {'specail-card': whichCard === 2} ]"  @mouseover="changeCard(2)">

              <div class="card-title">有限调度优质资源</div>
              <div class="card-detail">平台对雾计算设备的延迟和稳定性有评分机制，在为代理网关调度雾计算设备时，会优先选择优质资源进行分配，确保用户使用的代理节点稳定健康。</div>
            </div>
            <div v-bind:class="['card-detail-wrap', {'specail-card': whichCard === 3} ]"  @mouseover="changeCard(3)">
              <div class="card-title">用户接入高可用</div>
              <div class="card-detail">用户以域名+专属端口的形式介入代理网关集群，代理网关集群部署于负载均衡（LB）后端，LB的调度策略和健康检查确保了代理网关的高可用性和高性能。</div>
            </div>
          </div>
          <div class="right-content">
            <img
              v-if="whichCard === 1"
              class="use border"
              src="./../assets/ipDetail/use.png"
            >
            <img
              v-if="whichCard === 2"
              class="use border"
              src="./../assets/ipDetail/resource.png"
            >
            <img
              v-if="whichCard === 3"
              class="use border"
              src="./../assets/ipDetail/useable.png"
            >
          </div>
        </div>
        <div class="high-content">
          <div class="right">
            <img
              class="border reverse"
              src="./../assets/ipDetail/reversible.png"
            >
          </div>
          <div class="left">
            <div class="title">高安全</div>
            <div class="little-title">防范风控效果好</div>
            <div class="detail">雾计算节点分布于全球的家庭、办公、IDC等丰富的网络环境，IP资源实现边缘分布，对防范风控IP网段有很好的抵抗力。</div>
          </div>
        </div>

        <div class="high-content">
          <div class="left">
            <div class="title">高性能</div>
            <div class="detail distance">平台接入的海量雾计算设备均为网络在线设备，同时代理网关以集群模式提供服务，完美满足用户对高并发QPS的需求。</div>
            <div class="detail">平台管理了海量雾计算设备的宽带容量数据，根据用户需求可配置高宽带支持的专用代理集群服务。</div>
          </div>

          <div class="right">
            <img
              class="border perf"
              src="./../assets/ipDetail/perf.png"
            >
          </div>
        </div>

        <div class="high-content">
          <div class="right">
            <img
              class="border distribution"
              src="./../assets/ipDetail/distribution.png"
            >
          </div>
          <div class="left">
            <div class="title">海量广泛分布</div>
            <div class="detail distance">全球的新型社区化运营，确保了接入设备数量、地域的广泛与类型的丰富。</div>
            <div class="detail">基于区块链的网络资源整合，为覆盖全球的雾计算网络资源，购置稳定的生态环境。</div>
          </div>
        </div>
        <div class="high-content">
          <div class="left">
            <div class="title">灵活高效</div>
            <div class="detail distance">平台支持根据地域、运营商、带宽容量等多维度灵活调度网络资源，更好满足用户使用需求。</div>
            <div class="detail">平台支持定时、定量地自动变更代理IP，免除用户对目标封禁策略的重复开发测试。</div>
          </div>
          <div class="right">
            <img
              class="border reverse flexible"
              src="./../assets/ipDetail/flexible.png"
            >
          </div>
        </div>
      </div>
    </section>
    <section class="product-detail height-220">
      <div class="muhua-title advantage-title">了解如何使用沐桦动态代理网络服务</div>
      <div class="detail-wrap">
        <router-link to="/useDoc" class="button compute">
        查看产品文档
        </router-link>
        <router-link to="/customerCase" class="button compute white-button">
        查看案例
        </router-link>
      </div>
    </section>

    <Footer></Footer>
  </div>
</template>

<script>
// @ is an alias to /src
import { mapState, mapActions, mapMutations } from "vuex";
import Footer from "@/components/Footer.vue";
import Menu from "@/components/Menu.vue";
import Header from "@/components/Header.vue";

export default {
  name: "home",
  components: {
    Footer,
    Menu,
    Header
  },
  data() {
    return {
      activeIndex: "2-2-2",
      whichCard: 1,
      isSecondCard: false,
      isThirdCard: false,
    };
  },
  methods: {
    changeCard(value) {
      this.whichCard = value;
      console.log(123);
    }
  }
};
</script>

<style scoped lang="stylus">
.muhua-little-title {
  font-size: 14px;
}

.high-content {
  display: flex;
  text-align: left;
  margin-bottom: 94px;
  .left {
    width: 50%;
    .title {
      font-size: 24px;
      font-family: PingFangSC-Regular;
      font-weight: 400;
      color: rgba(63, 80, 124, 1);
      line-height: 34px;
    }
    .little-title {
      font-size: 16px;
      font-family: PingFangSC-Regular;
      font-weight: 400;
      color: rgba(63, 79, 124, 1);
      line-height: 21px;
      margin: 25px 0 9px;
    }
    .detail {
      font-size: 13px;
      font-family: PingFangSC-Regular;
      font-weight: 400;
      color: rgba(116, 133, 152, 1);
      line-height: 22px;
    }
    .distance {
      margin: 25px 0 19px;
    }
  }
  .right {
    width: 50%;
    text-align: center;
    img.reverse {
      width: 269px;
      height: 179px;
      max-width: 100%;
    }
    img.distribution {
      width: 234px;
      height: 234px;
      max-width: 100%;
    }
    img.flexible {
      width: 279px;
      height: 244px;
      max-width: 100%;
      margin-left: 40px;
    }
    img.perf {
      idth: 136px;
      height: 128px;
      max-width: 100%;
    }
  }
}

.feature {
  text-align: center;
  background: rgba(248, 252, 255, 1);
  .muhua-title {
    padding-bottom: 13px;
  }
  .little-title {
    margin-bottom: 34px;
  }
  .content {
    text-align: left;
    width: 65%;
    margin: 0 auto;
    padding-top: 48px;
    padding-bottom: 79px;
    .card {
      display: flex;
      margin-bottom: 96px;
      .left-content {
        width: 60%;
        .feature-title {
          font-size: 24px;
          font-family: PingFangSC-Regular;
          font-weight: 400;
          color: rgba(63, 80, 124, 1);
          line-height: 34px;
          margin-bottom: 16px;
        }
        .card-detail-wrap {
          font-size: 13px;
          font-family: PingFangSC-Regular;
          font-weight: 400;
          color: rgba(116, 133, 152, 1);
          line-height: 22px;
          padding: 10px 19px;
          margin-bottom: 16px;
        }
        .specail-card {
          background: rgba(255, 255, 255, 1);
          box-shadow: 0px 2px 8px 0px rgba(0, 174, 239, 0.1);
          border-radius: 5px;
          // margin-bottom: 0px;
        }
        .card-title {
          font-size: 16px;
          font-family: PingFangSC-Regular;
          font-weight: 400;
          color: rgba(63, 79, 124, 1);
          line-height: 21px;
          padding-bottom: 10px;
        }
        .card-detail {
          font-size: 13px;
          font-family: PingFangSC-Regular;
          font-weight: 400;
          color: rgba(116, 133, 152, 1);
          line-height: 22px;
        }
      }
      .right-content {
        width: 40%;
        img.use {
          width: 277px;
          height: 195px;
          margin: 48px 84px;
        }
      }
    }
  }
}

.ip-content {
  text-align: center;
  .content {
    font-size: 14px;
    font-family: PingFangSC-Regular;
    font-weight: 400;
    color: rgba(116, 133, 152, 1);
    line-height: 30px;
    max-width: 1000px;
    margin: 0 auto;
    width: 50%;
  }
  img {
    width: 50%;
    max-width: 1000px;
    margin: 34px 0 45px;
  }
}

.banner {
  background: #282A3C;
  width: 100%;
  height: 400px;
  display: flex;
  .banner-content {
    width: 80%;
    margin: 0 auto;
    display: flex;
    max-width: 1200px;
  }
  .left-banner {
    width: 59%;
    .title {
      margin: 121px 0 19px 0;
      font-size: 38px;
      font-family: PingFangSC-Regular;
      font-weight: 400;
      color: #fff;
      line-height: 64px;
    }
    .content {
      width: 383px;
      height: 90px;
      font-size: 12px;
      font-weight: 400;
      color: #fff;
      line-height: 23px;
      margin-bottom: 27px;
      font-size: 18px;
      font-family: PingFangSC-Regular;
      font-weight: 400;
      color: #fff;
      line-height: 32px;
    }
    .know-more {
      width: 96px;
      height: 31px;
      background: rgba(255, 255, 255, 1);
      border-radius: 2px;
      font-size: 11px;
      font-weight: 400;
      color: rgba(40, 42, 60, 1);
      line-height: 20px;
      text-align: center;
      line-height: 31px;
    }
  }
  .right-banner {
    width: 41%;
    img {
      height: 400px;
    }
  }
}
.product-detail {
  background-image: url('../assets/background/white_point.png');
  background-size: cover;
  .detail-wrap {
    display: flex;
    justify-content: space-between;
    width: 327px;
    margin: 0 auto;
  }
}
</style>
